import api, { API_BASE_URL, getCommuneSlug } from '../lib/axios';
import { getToken } from '../lib/auth';
export async function getAssistantStatus() {
    const { data } = await api.get('/api/admin/assistant/status');
    return data.data;
}
export async function getAssistantDoc(path) {
    const { data } = await api.get('/api/admin/assistant/docs', { params: { path } });
    return data.data;
}
export async function sendAssistantFeedback(messageId, value, comment) {
    await api.post(`/api/admin/assistant/messages/${messageId}/feedback`, { value, comment });
}
/** Erreur renvoyée par l'API avant le flux (accès, limite, message invalide), message en français. */
export class AssistantError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}
/**
 * Envoie une question et lit la réponse en flux (Server-Sent Events). axios ne
 * lit pas un flux : appel fetch, avec le jeton et la commune d'axios. Sur un 401
 * (jeton expiré), un appel axios déclenche le rafraîchissement puis on réessaie.
 */
export async function streamAssistantChat(body, onEvent, signal) {
    let response = await postChat(body, signal);
    if (response.status === 401) {
        await getAssistantStatus(); // l'intercepteur axios renouvelle le jeton
        response = await postChat(body, signal);
    }
    if (!response.ok || !response.body) {
        let message = "L'assistant ne répond pas. Réessayez dans quelques instants.";
        let code;
        try {
            const err = await response.json();
            message = err.error ?? message;
            code = err.code;
        }
        catch {
            /* réponse sans JSON : message par défaut */
        }
        throw new AssistantError(message, code);
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    for (;;) {
        const { value, done } = await reader.read();
        if (done)
            break;
        buffer += decoder.decode(value, { stream: true });
        let sep;
        while ((sep = buffer.indexOf('\n\n')) !== -1) {
            const raw = buffer.slice(0, sep);
            buffer = buffer.slice(sep + 2);
            const parsed = parseEvent(raw);
            if (parsed)
                onEvent(parsed);
        }
    }
}
function postChat(body, signal) {
    const headers = { 'Content-Type': 'application/json', Accept: 'text/event-stream' };
    const token = getToken();
    if (token)
        headers.Authorization = `Bearer ${token}`;
    const slug = getCommuneSlug();
    if (slug)
        headers['X-Commune-Slug'] = slug;
    return fetch(`${API_BASE_URL}/api/admin/assistant/chat`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
        signal,
    });
}
function parseEvent(raw) {
    let event = '';
    let data = '';
    for (const line of raw.split('\n')) {
        if (line.startsWith('event:'))
            event = line.slice(6).trim();
        else if (line.startsWith('data:'))
            data += line.slice(5).trim();
    }
    if (!event || !data)
        return null;
    try {
        return { event, data: JSON.parse(data) };
    }
    catch {
        return null;
    }
}
